import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_TEMPLATE_SIZE = "GET_LIST_TEMPLATE_SIZE";
export const GET_DETAIL_TEMPLATE_SIZE = "GET_DETAIL_TEMPLATE_SIZE";
export const UPDATE_TEMPLATE_SIZE = "UPDATE_TEMPLATE_SIZE";
export const SAVE_TEMPLATE_SIZE = "SAVE_TEMPLATE_SIZE";
export const DELETE_TEMPLATE_SIZE = "DELETE_TEMPLATE_SIZE";
export const SET_LIST_TEMPLATE_SIZE = "DELETE_TEMPLATE_SIZE";
export const SET_DETAIL_TEMPLATE_SIZE = "SET_DETAIL_TEMPLATE_SIZE";


const state = {
    listTemplateSize: [],
    templateSizeDetail: {}
};

const getters = {
    listTemplateSize(state) {
        return state.listTemplateSize;
    },
    templateSizeDetail(state) {
        return state.templateSizeDetail;
    },


};

const actions = {
    [GET_LIST_TEMPLATE_SIZE](context) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_LIST_TEMPLATE_SIZE}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_LIST_TEMPLATE_SIZE, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_TEMPLATE_SIZE](context,id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_TEMPLATE_SIZE}/${id}`).then(({data}) => {
                if (data.status) {
                    context.commit(SET_DETAIL_TEMPLATE_SIZE, data);
                }
                resolve(data);
            });
        });
    },
    [SAVE_TEMPLATE_SIZE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_TEMPLATE_SIZE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [UPDATE_TEMPLATE_SIZE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.UPDATE_TEMPLATE_SIZE}/${payload.id}?_method=PUT`, payload.data)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    [DELETE_TEMPLATE_SIZE](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_TEMPLATE_SIZE}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },

};

const mutations = {
    [SET_LIST_TEMPLATE_SIZE](state, data) {
        state.listTemplateSize = data.data;
    },
    [SET_DETAIL_TEMPLATE_SIZE](state, data) {
        state.templateSizeDetail = data.data;
    },


};

export default {
    state,
    actions,
    mutations,
    getters
};